import mapKnownValues from "@/utils/mapKnownValues";

export type PropertyTypeAPIResponse = {
  id: number;
  name: string;
  description: string;
};

export default class PropertyType {
  id = -1;
  name = "";
  description = "";

  constructor(params: Partial<PropertyType> = {}) {
    mapKnownValues(this, params);
  }

  static fromAPI(response: PropertyTypeAPIResponse) {
    return new PropertyType(response);
  }
}
